import React from 'react';
import closeIcon from '../Assets/Icons/close.png'
import infoIcon from '../Assets/Icons/Info-1.png'
import errorIcon from '../Assets/Icons/Alert circle.png'
import successIcon from '../Assets/Icons/Check circle-1.png'
import alertIcon from '../Assets/Icons/Alert triangle .png'
import { useNavigate } from 'react-router-dom';
import { logOutApiCall } from '../Utils/Exception';

// Reusable Notification Popup Component
const NotificationPopup = ({ type, title, bodyText, onClose }) => {
    let backgroundColor, icon, buttonText, borderColor, textColor, filter ;
  const navigate = useNavigate();
    // Set the popup type configurations
    switch (type) {
        case 'info':
            backgroundColor = '#FFFFFF'; // Light background for info
            icon = infoIcon; // Info icon
            buttonText = 'Ok';
            borderColor = '#757575'
            textColor = '#1E1E1E'
            filter = 'none'
            break;
        case 'error':
            backgroundColor = '#FEE9E7'; // Red background for error
            icon = errorIcon; // Error icon
            buttonText = 'Ok';
            borderColor = '#EC221F'
            textColor = '#900B09'
            filter = 'invert(28%) sepia(92%) saturate(2500%) hue-rotate(359deg) brightness(102%) contrast(102%)'
            break;
        case 'success':
            backgroundColor = '#EDF1D6'; // Green background for success
            icon = successIcon; // Success icon
            buttonText = 'Ok';
            borderColor = '#609966'
            textColor = '#40513B'
            filter = 'invert(23%) sepia(50%) saturate(350%) hue-rotate(125deg) brightness(100%) contrast(100%)'
            break;
        case 'warning':
            backgroundColor = '#FFFEF3'; // Yellow background for warning
            icon = alertIcon; // Warning icon
            buttonText = 'Ok';
            borderColor = '#BCA805'
            textColor = '#BCA805'
            filter = 'none';
            break;
        default:
            backgroundColor = '#FFFFFF'; // Default info background
            icon = infoIcon; // Default info icon
            buttonText = 'Ok';
            borderColor = '#757575'
            textColor = '#1E1E1E'
            filter = 'none'
    }

    const handleLogout = () => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        const emp_id = storedUserInfo?.emp_id;
        let reason = bodyText.includes("Your session has expired") 
            ? "session token expiration" 
            : "missing required information (device or organization ID)";
        logOutApiCall(emp_id, reason);
        setTimeout(() => {
            localStorage.removeItem('userRole');
            localStorage.removeItem('_userInfo_');
            // localStorage.clear();
            navigate('/login');
            onClose();
            window.location.reload(); 
        }, 500);

      };

    return (
        <div className="modal-overlay">
   <div
            style={{
                backgroundColor: backgroundColor,
                borderRadius: '8px',
                padding: '20px',
                width: '300px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                position: 'relative',
                border: '1px solid',
                borderColor:borderColor,
            }}
        >
            {/* Close button */}
            <button
                onClick={onClose}
                style={{
                    position: 'absolute',
                    top: '24px',
                    right: '10px',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                }}
            >
                <img src={closeIcon} alt='close' style={{width:'12px',filter:filter}} />
            </button>
            <div className='flexdisplay-left'>
                <img src={icon} alt='' style={{width:'16px'}} />

            {/* Title */}
            <h4 style={{ margin: 0, fontSize: '18px', color: textColor,fontFamily:'Roboto' }}>{title}</h4>
            </div>



            {/* Body Text */}
            <p style={{ margin: 0, fontSize: '14px',letterSpacing:'0.5px', color: textColor,fontFamily:'Roboto' }}>{bodyText}</p>

            {/* Action Button */}
            {/* <button
                onClick={onClose}
                style={{
                    padding: '10px 20px',
                    backgroundColor: 'var(--button-bg-color)',
                    color: 'var(--button-text-color)',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    border: 'none',
                    alignSelf: 'flex-start',
                    fontSize: '14px',
                }}
            >
                {buttonText}
            </button> */}
                        {/* Action Button */}
                        {title === 'Session Expired' ? 
            <button
                onClick={handleLogout}
                style={{
                    padding: '10px 20px',
                    backgroundColor: 'var(--button-bg-color)',
                    color: 'var(--button-text-color)',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    border: 'none',
                    alignSelf: 'flex-start',
                    fontSize: '14px',
                }}
            >
                Login
            </button>:
            <button
            onClick={onClose}
            style={{
                padding: '10px 20px',
                backgroundColor: 'var(--button-bg-color)',
                color: 'var(--button-text-color)',
                borderRadius: '20px',
                cursor: 'pointer',
                border: 'none',
                alignSelf: 'flex-start',
                fontSize: '14px',
            }}
        >
            {buttonText}
        </button>}
        </div>
        </div>
     
    );
};

export default NotificationPopup;
